const GET_BARCODE_REPORT_GRID_DATA = 'GET_BARCODE_REPORT_GRID_DATA';
const SET_BARCODE_REPORT_GRID_DATA = 'SET_BARCODE_REPORT_GRID_DATA';

const GET_BARCODE_REPORT_EXCEL_DATA = 'GET_BARCODE_REPORT_EXCEL_DATA';
const SET_BARCODE_REPORT_EXCEL_DATA = 'SET_BARCODE_REPORT_EXCEL_DATA';

const GET_BARCODE_REPORT_USER_DROPDOWN = 'GET_BARCODE_REPORT_USER_DROP_DOWN';
const SET_BARCODE_REPORT_USER_DROPDOWN = 'SET_BARCODE_REPORT_USER_DROP_DOWN';

const GET_BARCODE_REPORT_REGION_DROPDOWN = 'GET_BARCODE_REPORT_REGION_DROPDOWN';
const SET_BARCODE_REPORT_REGION_DROPDOWN = 'SET_BARCODE_REPORT_REGION_DROPDOWN';

const GET_BARCODE_REPORT_MARKET_DROPDOWN = 'GET_BARCODE_REPORT_MARKET_DROPDOWN';
const SET_BARCODE_REPORT_MARKET_DROPDOWN = 'SET_BARCODE_REPORT_MARKET_DROPDOWN';

const GET_BARCODE_REPORT_COSTCENTER_DROPDOWN = 'GET_BARCODE_REPORT_COSTCENTER_DROPDOWN';
const SET_BARCODE_REPORT_COSTCENTER_DROPDOWN = 'SET_BARCODE_REPORT_COSTCENTER_DROPDOWN';

const SET_BARCODE_REPORT_GRID_FILTERS = 'SET_BARCODE_REPORT_GRID_FILTERS';

const GET_BARCODE_REPORT_ASSET_IMAGES = 'GET_BARCODE_REPORT_ASSET_IMAGES';
const SET_BARCODE_REPORT_ASSET_IMAGES = 'SET_BARCODE_REPORT_ASSET_IMAGES';

const GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES = 'GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES';

export {
    GET_BARCODE_REPORT_GRID_DATA,
    SET_BARCODE_REPORT_GRID_DATA,
    GET_BARCODE_REPORT_EXCEL_DATA,
    SET_BARCODE_REPORT_EXCEL_DATA,
    GET_BARCODE_REPORT_USER_DROPDOWN,
    SET_BARCODE_REPORT_USER_DROPDOWN,
    GET_BARCODE_REPORT_REGION_DROPDOWN,
    SET_BARCODE_REPORT_REGION_DROPDOWN,
    GET_BARCODE_REPORT_MARKET_DROPDOWN,
    SET_BARCODE_REPORT_MARKET_DROPDOWN,
    GET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    SET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    SET_BARCODE_REPORT_GRID_FILTERS,
    GET_BARCODE_REPORT_ASSET_IMAGES,
    SET_BARCODE_REPORT_ASSET_IMAGES,
    GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES
};
